import React from "react";

export default function TriStateCheckbox({ value, onChange }) {
	const ref = React.useRef();

	React.useEffect(() => {
		if (ref.current) {
			ref.current.indeterminate = value === null || value === undefined;
		}
	}, [value]);

	const handleClick = () => {
		let next;
		if (value === null || value === undefined) next = true;
		else if (value === true) next = false;
		else next = null;

		onChange(next);
	};

	return (
		<input
			ref={ref}
			type="checkbox"
			checked={value === true}
			onChange={handleClick}
			style={{ width: 18, height: 18, cursor: "pointer" }}
		/>
	);
}
